import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/Blog28/image1.png";
import image2 from "../../../../assets/images/Blog28/image2.png";
import image14 from "../../../../assets/images/Blog28/image14.png";
import image3 from "../../../../assets/images/Blog28/image3 (2).png";
import image23 from "../../../../assets/images/Blog28/image23-28.png";
import image24 from "../../../../assets/images/Blog28/image24-28.png";
import image8 from "../../../../assets/images/Blog28/image8-28.png";
import image10 from "../../../../assets/images/Blog28/image10-28.png";
import image12 from "../../../../assets/images/Blog28/image12-28.png";
import image5 from "../../../../assets/images/Blog28/image5-28.png";
import image4 from "../../../../assets/images/Blog28/image4-28.png";
import image20 from "../../../../assets/images/Blog28/image20-28.png";
import image21 from "../../../../assets/images/Blog28/image21-2-28.png";
import image34 from "../../../../assets/images/Blog28/image34-28.png";
import image16 from "../../../../assets/images/Blog28/image16-28.png";
import image19 from "../../../../assets/images/Blog28/image19-28.png";
import image17 from "../../../../assets/images/Blog28/image17-28.png";
import image25 from "../../../../assets/images/Blog28/image25-28.png";
import image22 from "../../../../assets/images/Blog28/image22-28.png";

const Blog28 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – July 21st, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Gridlock in Japan, Melt-Up Momentum, and a Tariff Countdown into Earnings</p>
        <p>
          Markets continue their summer rally despite rising political dysfunction, tariff deadlines, and bubbling risk sentiment. As over 100 S&P companies prepare to report, traders are leaning into
          liquidity and narrative certainty. However, cracks beneath the surface—breadth divergences, retail-driven flows, and policy instability—suggest that volatility could return quickly.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: A Calm Surface, Cracks Beneath</p>
              <p>
                The bulls are still in control—for now. U.S. indices continue to grind higher, supported by strong Q2 earnings, high cash levels, and a surprising absence of volatility. But under the
                hood, the structure is weakening:
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Japan’s ruling coalition has lost both houses of government but refuses to step down, injecting fresh global uncertainty</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Trump doubled down on his
                    <span className="highlightedText">15–20% EU tariff demand,</span> locking in <span className="highlightedText">August 1</span> as a hard deadline
                  </p>
                </li>
                <li className="themesPointer">
                  <p>The Fed is now in blackout ahead of the July 30 FOMC, offering no reassurance as markets press higher</p>
                </li>
                <li className="themesPointer">
                  <p>Retail flows dominate while macro internals start to deteriorate</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Meanwhile, cash levels remain elevated, offering dip-buying fuel. However, with SPX having rallied strongly, participation thinning, and AI mania peaking, traders should exercise
                caution not to chase late-stage price action blindly.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Tariff Certainty, Fiscal Stress, and Dollar Deterioration</p>
              <p className="highlightedText">Japan’s Political Breakdown = Fiscal Creep Risk</p>
              <p>
                Markets expected a loss, but Ishiba’s coalition losing both houses and refusing to resign is a problem. The concern is that, to regain credibility, the government may resort to
                <span className="highlightedText"> spending increases or tax cuts,</span> thereby risking fiscal credibility. Japanese assets could wobble further if investor confidence erodes.
              </p>

              <p className="highlightedText">Trump’s August 1 Deadline is Set in Stone</p>
              <p>
                According to FT leaks, the White House is demanding a <span className="highlightedText">15–20% tariff on all EU goods.</span> Trump’s not bluffing—August 1 is now the line in the sand.
                While markets dislike the numbers, they love certainty. This gives risk assets breathing room to consolidate—unless the situation deteriorates.
              </p>

              <p className="highlightedText">Debt, Dollar & QE-by-Stealth</p>
              <p>
                With massive Treasury issuance looming, the Fed may be forced into buying government debt again. This is quiet QE, and it won’t go unnoticed—especially by gold, silver, and Bitcoin.
                The dollar remains <span className="highlightedText">expensive,</span> with<span className="highlightedText"> JPM’s effective dollar index still near cycle highs.</span>
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Fiat scepticism is building. The market sees through the math, and protection assets are responding.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Divergences Signal Late-Stage Behaviour</p>
              <p>The uptrend remains intact—but it’s increasingly narrow and speculative.</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>ACWI internals are diverging from price</p>
                </li>
                <li className="themesPointer">
                  <p>Non-profitable tech stocks have staged a wild V-shaped rebound</p>
                </li>
                <li className="themesPointer">
                  <p>Large caps are masking weakness under the surface</p>
                </li>
                <li className="themesPointer">
                  <p>Volatility metrics (VIX, MOVE) are flat despite mounting macro risks</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                AI continues to drive flows into speculative growth, pulling capital away from real economy sectors. With global equity valuations pushing against GDP ratios, the risk of mean
                reversion increases.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Retail is driving the bus. That means we’re in a <span className="highlightedText">short gamma environment</span> where dealers chase upside to manage exposure—until they don’t.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Cooling CPI, Hot Earnings, and Fed Uncertainty</p>
              <p className="highlightedText">Inflation: Soft Enough to Support Dovish Case</p>
              <p>U.S. data last week showed a modest inflation pulse:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CPI-PPI spread </span>suggested improving margins and weaker cost pressures
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">The Philly Fed index </span>jumped unexpectedly, crushing residual recession fears
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">University of Michigan survey </span>showed inflation expectations falling and consumer confidence rising
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image34}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image34)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>The Fed enters its blackout window split on what’s next:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Waller </span>argued for a July cut
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Daly </span> and <span className="highlightedText">Kugler</span> see a restrictive policy holding
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Goolsbee </span>flagged tariff-driven inflation as a new headwind
                  </p>
                </li>
              </ul>
              <p>All eyes now turn to the July 30 FOMC.</p>
              <p className="highlightedText">Earnings: Positive Surprises, Forward Revisions Lift</p>
              <p>
                Q2 earnings began with strong beats and <span>upward revisions</span> to FY25 and FY26 earnings. Buybacks and dividends are also trending higher, and investor positioning still
                suggests room to run.
              </p>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image16}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image16)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image19}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image19)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image17}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image17)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: ECB, Earnings Barrage, and Tokyo CPI</p>
              <p>It’s a packed week for central banks, earnings, and global sentiment gauges—Thursday steals the spotlight with flash PMIs and ECB fireworks.</p>

              <p className="highlightedText">Monday, July 21</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>NZ CPI, GBP Rightmove HPI</p>
                </li>

                <li className="themesPointer">
                  <p>CNY Loan Prime Rates (1Y & 5Y unch)</p>
                </li>
                <li className="themesPointer">
                  <p>CAD PPI, USD Leading Index</p>
                </li>
                <li className="themesPointer">
                  <p>France & U.S. short-term bill auctions</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, July 22</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>RBA Meeting Minutes</p>
                </li>
                <li className="themesPointer">
                  <p>USD Redbook, Richmond PMI, M2 Money Supply</p>
                </li>
                <li className="themesPointer">
                  <p>Powell and Bowman’s last scheduled appearances</p>
                </li>
                <li className="themesPointer">
                  <p>BOE’s Bailey speaks</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">Wednesday, July 23</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>BOJ Core CPI, EZ Consumer Confidence</p>
                </li>
                <li className="themesPointer">
                  <p>USD Existing Home Sales</p>
                </li>
                <li className="themesPointer">
                  <p>CAD New Housing Prices</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. 20Y Treasury auction</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, July 24</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Global Flash PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>ECB Rate Decision + Press Conference</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Jobless Claims, Building Permits, New Home Sales</p>
                </li>
                <li className="themesPointer">
                  <p>Fed Balance Sheet update, CAD Retail Sales</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, July 25</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Tokyo CPI, German IFO</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Durable Goods Orders, Atlanta GDPNow</p>
                </li>
                <li className="themesPointer">
                  <p>GBP Retail Sales, GfK Consumer Confidence</p>
                </li>
                <li className="themesPointer">
                  <p>EZ Money Supply, CAD Wholesale Sales</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Countdown to August 1</p>
              <p>
                Markets are holding up—but it’s fragile. Beneath the surface, signs of <span className="highlightedText">late-cycle excess </span>are clear:
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Breadth divergences</p>
                </li>
                <li className="themesPointer">
                  <p>Frothy retail-driven flows</p>
                </li>
                <li className="themesPointer">
                  <p>Currency instability</p>
                </li>
                <li className="themesPointer">
                  <p>Political interference in central banks</p>
                </li>
              </ul>
              <p>
                Still, liquidity is strong, cash is high, and earnings are beating. If the tariff risk is resolved cleanly, this market could rip into August. If not, the melt-up turns into a sharp
                repricing.
              </p>
              <p className="highlightedBoldText">Our stance: </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    Stay long quality names, but
                    <span className="highlightedText"> tighten stops</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Use pullbacks to add
                    <span className="highlightedText"> BTC, gold,</span> and real assets with tailwind stories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Watch
                    <span className="highlightedText"> Wednesday–Friday </span>this week: ECB, PMIs, and Durable Goods may shift tone
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image25}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image25)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1rRgKlV1Mu24uQ8lo4E6MC2GWn26p-LqUyEYZZ4mZztU/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog28;
